var map = {
	"./dragon_bowl.jpg": 156,
	"./eel_bowl.jpg": 157,
	"./garden_bowl.jpg": 158,
	"./hawaiian_classic.jpg": 159,
	"./johnnys_classic_bowl.jpg": 160,
	"./salmon_lover_bowl.jpg": 161,
	"./spicy_bowl.jpg": 162,
	"./spicy_house_bowl.jpg": 163
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image ^\.\/.*$
// module id = 155
// module chunks = 0